/**
 * 업무관리 > 보고서 서브메뉴 정본.
 * 보고서를 추가·변경하면 이 목록과 함께 routes.js, permissions.js,
 * instructions/menu-source-mapping.md를 갱신한다.
 */
export const REPORT_MENUS = [
    { key: 'sales', label: '매출', path: '/partner/report/sales' },
    { key: 'customer-monthly-sales', label: '고객별 월별 매출', path: '/partner/report/customer-monthly-sales' },
    { key: 'as-consumable-cost', label: 'A/S 부소모품 비용', path: '/partner/report/as-consumable-cost' },
    { key: 'sales-vs-consumable-cost', label: '매출 VS 부소모품 비용', path: '/partner/report/sales-vs-consumable-cost' },
    { key: 'customer-count', label: '고객수', path: '/partner/report/customer-count' },
    { key: 'equipment-count', label: '장비대수', path: '/partner/report/equipment-count' },
    { key: 'usage', label: '사용량', path: '/partner/report/usage' },
    { key: 'as-type', label: 'AS 유형', path: '/partner/report/as-type' },
    { key: 'engineer', label: '엔지니어', path: '/partner/report/engineer' },
];
